var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormCategory.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormCategory.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormInformationFilm.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormInformationFilm.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormMembers.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormMembers.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormSets.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormSets.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormTotalSets.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormTotalSets.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormUploadPoster.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormUploadPoster.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormUploadPresentation.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormUploadPresentation.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormUploadClip.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormUploadClip.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormSubmitterInfo.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormSubmitterInfo.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormContributors.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormContributors.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormMaterials.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormMaterials.jinja" );
dependencies["submissions/components/SubmissionForm/SubmissionFormConfirm.jinja"] = require( "submissions/components/SubmissionForm/SubmissionFormConfirm.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormCategory.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "SubmissionFormCategory")) {
var t_7 = t_4.SubmissionFormCategory;
} else {
cb(new Error("cannot import 'SubmissionFormCategory'")); return;
}
context.setVariable("SubmissionFormCategory", t_7);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormInformationTv.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "SubmissionFormInformationTv")) {
var t_11 = t_8.SubmissionFormInformationTv;
} else {
cb(new Error("cannot import 'SubmissionFormInformationTv'")); return;
}
context.setVariable("SubmissionFormInformationTv", t_11);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormEpisodes.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "SubmissionFormEpisodes")) {
var t_15 = t_12.SubmissionFormEpisodes;
} else {
cb(new Error("cannot import 'SubmissionFormEpisodes'")); return;
}
context.setVariable("SubmissionFormEpisodes", t_15);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormInformationFilm.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
t_16.getExported(function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
if(Object.prototype.hasOwnProperty.call(t_16, "SubmissionFormInformationFilm")) {
var t_19 = t_16.SubmissionFormInformationFilm;
} else {
cb(new Error("cannot import 'SubmissionFormInformationFilm'")); return;
}
context.setVariable("SubmissionFormInformationFilm", t_19);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormMembers.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_21,t_20) {
if(t_21) { cb(t_21); return; }
t_20.getExported(function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
if(Object.prototype.hasOwnProperty.call(t_20, "SubmissionFormMembers")) {
var t_23 = t_20.SubmissionFormMembers;
} else {
cb(new Error("cannot import 'SubmissionFormMembers'")); return;
}
context.setVariable("SubmissionFormMembers", t_23);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormSets.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_25,t_24) {
if(t_25) { cb(t_25); return; }
t_24.getExported(function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
if(Object.prototype.hasOwnProperty.call(t_24, "SubmissionFormSets")) {
var t_27 = t_24.SubmissionFormSets;
} else {
cb(new Error("cannot import 'SubmissionFormSets'")); return;
}
context.setVariable("SubmissionFormSets", t_27);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormTotalSets.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
t_28.getExported(function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
if(Object.prototype.hasOwnProperty.call(t_28, "SubmissionFormTotalSets")) {
var t_31 = t_28.SubmissionFormTotalSets;
} else {
cb(new Error("cannot import 'SubmissionFormTotalSets'")); return;
}
context.setVariable("SubmissionFormTotalSets", t_31);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormUploadPoster.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_33,t_32) {
if(t_33) { cb(t_33); return; }
t_32.getExported(function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
if(Object.prototype.hasOwnProperty.call(t_32, "SubmissionFormUploadPoster")) {
var t_35 = t_32.SubmissionFormUploadPoster;
} else {
cb(new Error("cannot import 'SubmissionFormUploadPoster'")); return;
}
context.setVariable("SubmissionFormUploadPoster", t_35);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormUploadPresentation.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_37,t_36) {
if(t_37) { cb(t_37); return; }
t_36.getExported(function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
if(Object.prototype.hasOwnProperty.call(t_36, "SubmissionFormUploadPresentation")) {
var t_39 = t_36.SubmissionFormUploadPresentation;
} else {
cb(new Error("cannot import 'SubmissionFormUploadPresentation'")); return;
}
context.setVariable("SubmissionFormUploadPresentation", t_39);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormUploadClip.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_41,t_40) {
if(t_41) { cb(t_41); return; }
t_40.getExported(function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
if(Object.prototype.hasOwnProperty.call(t_40, "SubmissionFormUploadClip")) {
var t_43 = t_40.SubmissionFormUploadClip;
} else {
cb(new Error("cannot import 'SubmissionFormUploadClip'")); return;
}
context.setVariable("SubmissionFormUploadClip", t_43);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormSubmitterInfo.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_45,t_44) {
if(t_45) { cb(t_45); return; }
t_44.getExported(function(t_46,t_44) {
if(t_46) { cb(t_46); return; }
if(Object.prototype.hasOwnProperty.call(t_44, "SubmissionFormSubmitterInfo")) {
var t_47 = t_44.SubmissionFormSubmitterInfo;
} else {
cb(new Error("cannot import 'SubmissionFormSubmitterInfo'")); return;
}
context.setVariable("SubmissionFormSubmitterInfo", t_47);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormContributors.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_49,t_48) {
if(t_49) { cb(t_49); return; }
t_48.getExported(function(t_50,t_48) {
if(t_50) { cb(t_50); return; }
if(Object.prototype.hasOwnProperty.call(t_48, "SubmissionFormContributors")) {
var t_51 = t_48.SubmissionFormContributors;
} else {
cb(new Error("cannot import 'SubmissionFormContributors'")); return;
}
context.setVariable("SubmissionFormContributors", t_51);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormMaterials.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_53,t_52) {
if(t_53) { cb(t_53); return; }
t_52.getExported(function(t_54,t_52) {
if(t_54) { cb(t_54); return; }
if(Object.prototype.hasOwnProperty.call(t_52, "SubmissionFormMaterials")) {
var t_55 = t_52.SubmissionFormMaterials;
} else {
cb(new Error("cannot import 'SubmissionFormMaterials'")); return;
}
context.setVariable("SubmissionFormMaterials", t_55);
output += "\n";
env.getTemplate("submissions/components/SubmissionForm/SubmissionFormConfirm.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja", false, function(t_57,t_56) {
if(t_57) { cb(t_57); return; }
t_56.getExported(function(t_58,t_56) {
if(t_58) { cb(t_58); return; }
if(Object.prototype.hasOwnProperty.call(t_56, "SubmissionFormConfirm")) {
var t_59 = t_56.SubmissionFormConfirm;
} else {
cb(new Error("cannot import 'SubmissionFormConfirm'")); return;
}
context.setVariable("SubmissionFormConfirm", t_59);
output += "\n\n";
var macro_t_60 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_61 = "";t_61 += "\n    <div class=\"SubmissionForm\">\n\n        ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"onlyUploads")) {
t_61 += "\n            <div class=\"SubmissionForm-block\">\n                <div class=\"SubmissionForm-blockWrapper\">\n                    <h2>PROJECT DETAILS</h2>\n                    ";
t_61 += runtime.suppressValue((lineno = 25, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormCategory"), "SubmissionFormCategory", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n\n                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"typ") == "tv") {
t_61 += "\n                        ";
t_61 += runtime.suppressValue((lineno = 28, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormInformationTv"), "SubmissionFormInformationTv", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                        ";
t_61 += runtime.suppressValue((lineno = 29, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormEpisodes"), "SubmissionFormEpisodes", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                    ";
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"typ") == "film") {
t_61 += "\n                        ";
t_61 += runtime.suppressValue((lineno = 31, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormInformationFilm"), "SubmissionFormInformationFilm", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                    ";
;
}
;
}
t_61 += "\n                </div>\n            </div>\n\n            <div class=\"SubmissionForm-block\">\n                <div class=\"SubmissionForm-blockWrapper\">\n                    <h2>DESIGN TEAM</h2>\n                    <div class=\"SubmissionForm-blockDescription\"><p>The following crafts are recognized by the ADG Awards: Production Designer, Art Director, Assistant Art Director, Supervising Art Director, Visual Consultant, Scenic Artist, Graphic Designer, Graphic Artist, Title Artist, Illustrator, Matte Artist, Storyboard Artist, Concept Artist, Previs Artist, Set Designer (Draughtsperson), Digital Set Designer, Model Maker, Digital Model Maker, Set Decorator.</p><p></p><p>Please note that the number of nomination certificates is limited to fifteen (15) for non-ADG members per project. The Production Designer for any project with more than fifteen (15) non-ADG members must organize the payment for the additional certficates or they will not be ordered.</p><p></p><p>The cost of each certificate is $5, plus shipping (shipping costs may vary from $1.75 to $6.50). If you are unsure as to what crafts should be included, please contact Debbie Patton: <a href=\"tel:818-762-9995\">818.762.9995</a> or <a href=\"mailto:debbie@adg.org\">debbie@adg.org</a></p></div>\n                    ";
t_61 += runtime.suppressValue((lineno = 40, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormMembers"), "SubmissionFormMembers", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                </div>\n            </div>\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"typ") == "tv") {
t_61 += "\n                <div class=\"SubmissionForm-block\">\n                    <div class=\"SubmissionForm-blockWrapper\">\n                        <h2>SET & TIMING<br>INFORMATION</h2>\n                        <div class=\"SubmissionForm-blockDescription\">For series not in their premiere season, 60% screen time or 60% set count must be in new sets or locations for design teams to qualify for submission.  The submission may include new sets or locations from up to three different episodes. The episodes must be entered in the order they aired, up to a cap of three until the 60% mark is met.  Once the “60% new” requirement has been met, no additional episodes are eligible. Location work must be significantly redressed or designed to count toward the 60% requirement.  For all such series, a set list with timing breakdown for each submitted episode must be uploaded, enter a summary of the timings and set counts in the space provided below and two (2) DVD copies of the entered episode (s) must be sent to the ADG Awards Office.</div>\n                        ";
t_61 += runtime.suppressValue((lineno = 49, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormSets"), "SubmissionFormSets", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                        ";
t_61 += runtime.suppressValue((lineno = 50, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormTotalSets"), "SubmissionFormTotalSets", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                    </div>\n                </div>\n            ";
;
}
t_61 += "\n        ";
;
}
t_61 += "\n\n        <div class=\"SubmissionForm-block\">\n            <div class=\"SubmissionForm-blockWrapper\">\n                <h2>UPLOAD ASSETS</h2>\n                <div class=\"SubmissionForm-blockDescription\">The following assets are what will be shown to the public on the ADG.org website if you get nominated. You can submit your project as long as you have completed all required fields, and return to this submission before the deadline to include your assets. You can also save your submission at any time.</div>\n                ";
t_61 += runtime.suppressValue((lineno = 60, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormUploadPoster"), "SubmissionFormUploadPoster", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"ind": 1})])), env.opts.autoescape);
t_61 += "\n                ";
t_61 += runtime.suppressValue((lineno = 61, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormUploadPresentation"), "SubmissionFormUploadPresentation", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"ind": 2})])), env.opts.autoescape);
t_61 += "\n                ";
t_61 += runtime.suppressValue((lineno = 62, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormUploadClip"), "SubmissionFormUploadClip", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data"),"ind": 3})])), env.opts.autoescape);
t_61 += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"onlyUploads")) {
t_61 += "\n                    ";
t_61 += runtime.suppressValue((lineno = 65, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormContributors"), "SubmissionFormContributors", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                ";
;
}
t_61 += "\n            </div>\n        </div>\n\n        ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"onlyUploads")) {
t_61 += "\n            <div class=\"SubmissionForm-block\">\n                <div class=\"SubmissionForm-blockWrapper\">\n                    <h2>WHO IS SUBMITTING<br>THIS PROJECT?</h2>\n                    ";
t_61 += runtime.suppressValue((lineno = 74, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormSubmitterInfo"), "SubmissionFormSubmitterInfo", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                    ";
t_61 += runtime.suppressValue((lineno = 75, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormContributors"), "SubmissionFormContributors", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                </div>\n            </div>\n\n            <div class=\"SubmissionForm-block\">\n                <div class=\"SubmissionForm-blockWrapper\">\n                    <h2>SUBMISSION MATERIALS</h2>\n                    ";
t_61 += runtime.suppressValue((lineno = 82, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormMaterials"), "SubmissionFormMaterials", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                    ";
t_61 += runtime.suppressValue((lineno = 83, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "SubmissionFormConfirm"), "SubmissionFormConfirm", context, [runtime.makeKeywordArgs({"data": runtime.contextOrFrameLookup(context, frame, "data")})])), env.opts.autoescape);
t_61 += "\n                </div>\n            </div>\n        ";
;
}
t_61 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_61);
});
context.addExport("SubmissionForm");
context.setVariable("SubmissionForm", macro_t_60);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionForm.jinja
// module id = 50
// module chunks = 0